import { ReactElement } from 'react';
import chunk from 'lodash/fp/chunk';
import { formatISO } from 'date-fns/fp';

import Day from './Day';
import type { DayProps } from './Day';
import WeekHeader from './WeekHeader';

export type Days = Array<DayProps | null>;

type Props = {
	renderWeekHeader?: boolean;
	firstDayOfWeek: number;
	title: string;
	days: Days;
};

export default function Month({
	renderWeekHeader = true,
	firstDayOfWeek,
	title,
	days,
}: Props): ReactElement {
	return (
		<div className="CalendarMonthGrid_month__horizontal ">
			<div className="CalendarMonth">
				<div className="CalendarMonth_caption">
					<strong>{title}</strong>
				</div>
				<table className="CalendarMonth_table" role="presentation">
					{renderWeekHeader && <WeekHeader firstDayOfWeek={firstDayOfWeek} />}
					<tbody>
						{chunk(7)(days).map((days, i) => (
							<tr key={i}>
								{days.map((dayValues, index) => {
									if (!dayValues) {
										return <td key={`${index}-blank`} />;
									}

									const {
										date,
										tabIndex,
										ariaLabel,
										isSelected,
										isSelectedStart,
										isSelectedEnd,
										isRestricted,
										isUnavailable,
										disabled,
										onClick,
									} = dayValues;

									return (
										<Day
											key={formatISO(date)}
											date={date}
											tabIndex={tabIndex}
											ariaLabel={ariaLabel}
											isSelected={isSelected}
											isSelectedStart={isSelectedStart}
											isSelectedEnd={isSelectedEnd}
											isRestricted={isRestricted}
											isUnavailable={isUnavailable}
											disabled={disabled}
											onClick={onClick}
										/>
									);
								})}
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
}
